<template>
  <PSMonthMoniToring />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
